import isEmpty from 'lodash/isEmpty'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { useSavedCheckoutLocalData } from '@Domains/Checkout/Hooks/useSavedCheckoutLocalData'

export const usePreviousStoredAdyenData = <T extends { isValid: boolean, type: string }>(type: string) => {
  const [prevPaymentData, setPrevPaymentData] = useState<null | T>(null)
  const { checkoutLocal } = useSavedCheckoutLocalData()

  useEffect(() => {
    const data = checkoutLocal
    if (data?.savedPaymentInputData) {
      const prev = (data.savedPaymentInputData as T)
      setPrevPaymentData(prev.type === type ? prev : null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutLocal])

  const getPaymentData = useCallback((adyenComponent, newData) => {
    let paymentData: T | null = prevPaymentData
    if (!prevPaymentData && adyenComponent) {
      paymentData = newData
    }
    return paymentData
  }, [prevPaymentData])

  const removePreviousData = useCallback(() => setPrevPaymentData(null), [])
  const hasPreviousData = useMemo(() => !isEmpty(prevPaymentData), [prevPaymentData])
  return {
    prevPaymentData,
    getPaymentData,
    hasPreviousData,
    removePreviousData,
    setPrevPaymentData,
  }
}
